import { render } from "./NavMenu.vue?vue&type=template&id=2b9d18d4"
import script from "./NavMenu.vue?vue&type=script&lang=js"
export * from "./NavMenu.vue?vue&type=script&lang=js"
script.render = render

export default script